import { React, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown, Form, Button, Icon } from 'semantic-ui-react'
import { history } from '../../../redux/store'
import {
  setCustomerData,
  setCustomerName,
} from '../../../redux/actions/facility'
import styles from '../facility-info-view/facility-view.module.css'
// import { FacilityViewContext } from '../facility-info-view/facilityView'
// import classes from './facilityList.module.css'
import IntelMsg from '../../ItelMsg'
// import {
//   GetPaginationFacilityList,
//   GetPaginationCustomersListWithSearch,
// } from '../../../services/facility'
import { GetUserCustomers } from '../../../services/asset/index'
import TreeHierarchy from '../../customers/actions/customerHierarchy/adminTreeHierarchy'
import StatusDialog from '../../status-dialog'
import CustomerHierarchy from '../../customers/actions/customerHierarchy/customerHierarchy.component'

const FacilitiesList = () => {
  // const [facilityList, setFacilityList] = useState([])
  // const [noOfPages, setNoOfPages] = useState(0)
  const [showStatusDialog, setShowStatusDialog] = useState(false)
  const [dialogContent] = useState(<></>)
  // const [pageSize] = useState(10)

  // const [activePage, setActivePage] = useState(0)
  const [customersList, setCustomersList] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState(
    localStorage.getItem('customer'),
  )

  const customerData = []
  const dispatch = useDispatch()

  const [customerName, setCustomername] = useState()

  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const productName = localStorage.getItem('product')
  // const { refreshCustomerList } = useSelector((store) => ({
  //   refreshCustomerList: store.customer.refreshCustomerList,
  // }))
  useEffect(() => {
    if (selectedCustomer) {
      dispatch(setCustomerData(selectedCustomer))
      dispatch(setCustomerName(customerName))
    }
  }, [selectedCustomer])

  useEffect(() => {
    GetUserCustomers(userEmail, productName).then((customers) => {
      customers.forEach((customer) => {
        customerData.push({
          text: customer.title,
          value: customer.tbCustomerId,
        })
      })
      console.log('customers', customers)
      setCustomersList(customerData)
    })
  }, [])

  useEffect(() => {
    if (selectedCustomer) {
      dispatch(setCustomerName(customerName))
    }
  }, [selectedCustomer])
  // function filteringCriteria(prop) {
  //   if (searchCriteria === 'status') {
  //     return prop.status.includes(searchTerm)
  //   }
  //   if (searchCriteria === 'name') {
  //     if (prop.name) {
  //       return prop.title
  //         .toUpperCase()
  //         .includes(searchTerm.toUpperCase().split(' ').join(''))
  //     }
  //   }

  //   return prop.name
  //     .toLocaleLowerCase()
  //     .includes(searchTerm.toLocaleLowerCase().split(' ').join(''))
  // }

  // const getDialogContent = (success, msg) => {
  //   if (success) {
  //     return (
  //       <>
  //         <Icon name="check" size="huge" color="green" />
  //         <div style={{ fontSize: 'x-large' }}>{msg}</div>
  //       </>
  //     )
  //   }
  //   return (
  //     <>
  //       <Icon name="exclamation triangle" size="huge" color="red" />
  //       <div style={{ fontSize: 'x-large' }}>{msg}</div>
  //     </>
  //   )
  // }

  // const changeCustomerStatusOnClick = async (item) => {
  //   dispatch(RefreshUserCustomersList(false))
  //   console.log('delete', item)
  //   let content = <></>
  //   try {
  //     const response = await changeCustomerStatus(productName, item.title)

  //     if (response.success) {
  //       content = getDialogContent(
  //         true,
  //         response.message ? response.message : 'Status changed!',
  //       )
  //       setDialogContent(content)
  //       setShowStatusDialog(true)
  //       dispatch(RefreshUserCustomersList(true))
  //     } else {
  //       let { msg } = response
  //       msg = Array.isArray(msg) ? msg.map((error) => <div>{error}</div>) : msg
  //       content = getDialogContent(false, msg || 'Status Changed!')
  //       setDialogContent(content)
  //       setShowStatusDialog(true)
  //       dispatch(RefreshUserCustomersList(true))
  //     }
  //   } catch (e) {
  //     let { msg } = e
  //     msg = Array.isArray(msg)
  //       ? msg.map((error) => (
  //           <>
  //             <div>{error}</div>
  //             <br />
  //           </>
  //         ))
  //       : msg
  //     setDialogContent(getDialogContent(false, msg || 'Customer Not Changed'))
  //     setShowStatusDialog(true)
  //   }
  // }
  // const onDetailsClick = async (item) => {
  //   try {
  //     const customerData = await GetCustomerInfo(email, item.title)
  //     console.log('customerData', customerData)
  //     setFacilityrData(customerData)
  //     setViewFacility(true)
  //     dispatch(RefreshUserFacilitiesList(true))
  //   } catch (e) {
  //     setDialogContent(
  //       <>
  //         <Icon name="exclamation triangle" size="huge" color="red" />
  //         <p style={{ fontSize: 'x-large' }}>{e.message}</p>
  //       </>,
  //     )
  //     setShowStatusDialog(true)
  //   }
  // }
  // const onChange = (e, pageInfo) => {
  //   setActivePage(pageInfo.activePage - 1)
  // }

  // const listItems =
  //   facilityList.length > 0 ? (
  //     facilityList.map((item) => (
  //       <Table.Row key={item['asset name']}>
  //         <Table.Cell width={5}>{item['asset name']}</Table.Cell>
  //         <Table.Cell width={5}>{item['asset type']}</Table.Cell>
  //         <Table.Cell width={2}>
  //           <Button
  //             animated
  //             size="medium"
  //             // onClick={() => onDetailsClick(item)}
  //           >
  //             <Button.Content hidden>
  //               <IntelMsg id="Details" />
  //             </Button.Content>
  //             <Button.Content visible>
  //               <Icon name="ellipsis horizontal" />
  //             </Button.Content>
  //           </Button>
  //           {/* <Button
  //               animated
  //               size="medium"
  //               onClick={() => changeCustomerStatusOnClick(item)}
  //             >
  //               <Button.Content hidden>
  //                 {item.status === 'Inactive' ? ' Activate ' : ' DeActive '}
  //               </Button.Content>
  //               <Button.Content visible>
  //                 <Icon name="recycle" />
  //               </Button.Content>
  //             </Button> */}
  //         </Table.Cell>
  //       </Table.Row>
  //     ))
  //   ) : (
  //     <Table.Row>
  //       <Table.Cell colSpan="3">
  //         <p style={{ textAlign: 'center' }}>
  //           <strong>
  //             <IntelMsg id="thereIsNoFacilitiesToShow" />
  //           </strong>
  //         </p>
  //       </Table.Cell>
  //     </Table.Row>
  //   )

  return (
    <>
      <Form.Field style={{ marginTop: '1rem', marginBottom: '1rem' }}>
        <Dropdown
          placeholder="You have to select Customer"
          fluid
          search
          selection
          options={customersList}
          onKeyPress={(e) => {
            const title = e.target.innerHTML.replace('<span class="text">', '')
            setCustomername(title.replace('</span>', ''))
            dispatch(setCustomerName(title.replace('</span>', '')))
            localStorage.setItem('customerName', title.replace('</span>', ''))
            // setSelectedCustomer(data.value)
            // dispatch(setCustomerData(data.value))
          }}
          onChange={(e, data) => {
            const title = e.target.innerHTML.replace('<span class="text">', '')
            setCustomername(title.replace('</span>', ''))
            dispatch(setCustomerName(title.replace('</span>', '')))
            localStorage.setItem('customerName', title.replace('</span>', ''))
            setSelectedCustomer(data.value)
            localStorage.setItem('customer', data.value)
            dispatch(setCustomerData(data.value))
          }}
          value={selectedCustomer || ''}
        />
      </Form.Field>
      <CustomerHierarchy />
      <br />
      <div className={styles.container}>
        {customerName}
        <IntelMsg id="Hierarchy" />
      </div>
      {selectedCustomer && <TreeHierarchy />}

      {/* <Table compact celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <IntelMsg id="facilityName" />
            </Table.HeaderCell>
            <Table.HeaderCell collapsing>
              <IntelMsg id="Type" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <IntelMsg id="actions" />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body className={classes.tableBody}>
          <>{listItems}</>
        </Table.Body>
      </Table> */}
      {/* <Table.Footer className={classes.footer} colSpan={2}>
        <Pagination
          floating="right"
          activePage={activePage + 1}
          onPageChange={(e, data) => onChange(e, data)}
          totalPages={noOfPages}
          firstItem={{
            content: <Icon name="angle double left" />,
            icon: true,
          }}
          lastItem={{
            content: <Icon name="angle double right" />,
            icon: true,
          }}
          prevItem={{ content: <Icon name="angle left" />, icon: true }}
          nextItem={{ content: <Icon name="angle right" />, icon: true }}
        />
      </Table.Footer> */}
      <StatusDialog
        showDialog={showStatusDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={<IntelMsg id="Customer" />}
        dialogContent={dialogContent}
      />
      <div className={styles.actions}>
        <Button
          form="customerSettings"
          type="submit"
          style={{ backgroundColor: '#303d54', color: 'white' }}
          onClick={() => {
            if (productName === 'tank') history.push('/Tank')
            else history.push('/cold')
          }}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
      </div>
    </>
  )
}

FacilitiesList.propTypes = {}
export default FacilitiesList
